/* eslint-disable */
import { Box, Dialog, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
  BoxCmt
} from "./TutorialBox.styles";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore, useCurrentCommunityCluster } from "../../stores";
import { NAVBAR_ITEMS } from "../../consts";
import { getLastPath } from "../../utils/general";
import {alpha} from "@mui/material/styles";
import {ButtonDigited} from "../Button/Button.variants";
import { ChevronRight, X} from "lucide-react";

interface TutorialInterface {
  onMobileShowWidget?: (item: boolean) => void,
  onMobileShowUserMenu?: (item: boolean) => void,
  sessionToken?: string | null,
  origin?: string
}
const TutorialBox: React.FC<TutorialInterface> = ({ onMobileShowWidget, onMobileShowUserMenu, sessionToken, origin }) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const theme = useTheme();
  const [showTutorial, setShowTutorial] = useState(true)
  const [activeStep, setActiveStep] = useState(0)
  const tutorialBoxRef = useRef(null)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const smartConfiguration = useAuthStore(state => state.smartConfiguration);
  const enableCommunityFlag = useAuthStore(state => state.corporateInfo?.enable_community_flag);
  const { availableClusters: clusters } = useCurrentCommunityCluster();

  const steps = useMemo(() => {
    let items = [
      {
        title: t("tutorial-step-1-title"),
        firstText: t("tutorial-step-1-firstText"),
        secondText: t("tutorial-step-1-secondText"),
        stepNumber: "1",
      },
      {
        title: t("tutorial-step-2-title"),
        firstText: t("tutorial-step-2-firstText"),
        secondText: t("tutorial-step-2-secondText"),
        id: "navbar",
        elementRef: "bottom-navigation-for-you",
        idStep: NAVBAR_ITEMS.FOR_YOU,
        stepNumber: "2",
        href: "/per-te"
      },
      {
        title: t("tutorial-step-3-title"),
        firstText: t("tutorial-step-3-firstText"),
        secondText: t("tutorial-step-3-secondText"),
        id: "side-menu",
        stepNumber: "3"
      },
      {
        title: t("tutorial-step-4-title"),
        firstText: t("tutorial-step-4-firstText"),
        secondText: t("tutorial-step-4-secondText"),
        id: "navbar",
        elementRef: "bottom-navigation-explore",
        stepNumber: "4",
        href: "/esplora"
      },
      {
        title: t("tutorial-step-5-title"),
        firstText: t("tutorial-step-5-firstText"),
        secondText: t("tutorial-step-5-secondText"),
        id: "navbar",
        elementRef: "bottom-navigation-bookmarks",
        stepNumber: "5",
        idStep: NAVBAR_ITEMS.BOOKMARKS,
        href: "/bookmarks"
      },
      {
        title: t("tutorial-step-6-title"),
        firstText: t("tutorial-step-6-firstText"),
        secondText: t("tutorial-step-6-secondText"),
        id: "navbar",
        elementRef: "bottom-navigation-community",
        stepNumber: "6",
        idStep: NAVBAR_ITEMS.COMMUNITY,
        href: "/community"
      },
      {
        title: t("tutorial-step-7-title"),
        firstText: t("tutorial-step-7-firstText"),
        secondText: t("tutorial-step-7-secondText"),
        id: "navbar",
        elementRef: "bottom-navigation-agenda",
        stepNumber: "7",
        idStep: NAVBAR_ITEMS.AGENDA,
        href: "/agenda"
      },
      {
        title: t("tutorial-step-8-title"),
        firstText: t("tutorial-step-8-firstText"),
        secondText: t("tutorial-step-8-secondText"),
        stepNumber: "8",
        id: "app-bar",
        elementRef: "chatbot",
        href: "/per-te"
      }
    ]

    if (smartConfiguration?.visForyou === false) {
      items = items.filter((item) => item.idStep !== NAVBAR_ITEMS.FOR_YOU);
    }
    if (smartConfiguration?.funcFavourites === false) {
      items = items.filter((item) => item.idStep !== NAVBAR_ITEMS.BOOKMARKS);
    }
    if (
      enableCommunityFlag === false
      || (enableCommunityFlag === true && smartConfiguration?.funcCommunity === false) || (clusters.length == 0)
    ) {
      items = items.filter((item) => item.idStep !== NAVBAR_ITEMS.COMMUNITY);
    }
    if (smartConfiguration?.widgetCalendar === false) {
      items = items.filter((item) => item.idStep !== NAVBAR_ITEMS.AGENDA);
    }

    if (smartConfiguration?.widgetBadge === false && smartConfiguration?.widgetCalendar === false && smartConfiguration?.widgetContinueLearning === false) {
      items = items.filter((item) => item.id !== "side-menu");
    }

    return items;
  }, [smartConfiguration, enableCommunityFlag, t])

  const closeTutorial = () => {
    const elementToRemove = document.querySelector(`#${steps[activeStep].id}-clone`)
    elementToRemove?.remove()
    setShowTutorial(false)
    const isLocalhost = (location.hostname == "localhost" || location.hostname === "127.0.0.1");
    const expirationDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365); // 1 year

    //Clean older cookies
    document.cookie.split(";").forEach((cookie) => {
      const cookieName = cookie.split("=")[0].trim();
      if (cookieName.startsWith("tutorial-completed"))
        document.cookie = `${cookieName}=;secure; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${getLastPath()}; path=/`;
    });

    const cookieName = sessionToken ? `tutorial-completed-${sessionToken}` : "tutorial-completed";
    document.cookie = `${cookieName}=true;${!isLocalhost ? 'secure;' : ''} expires=${expirationDate.toUTCString()}; ${!isLocalhost ? 'domain=.' + getLastPath() : ''}; path=/`;
    navigate(origin ?? "/");
  }

  const goToNextStep = () => {
    const elementsToRemove = document.querySelectorAll(`#${steps[activeStep].id}-clone`);

    elementsToRemove.forEach(element => {
      element?.remove()
    });

    if (steps.length - 1 === activeStep) {
      setShowTutorial(false)
      if(origin) navigate(origin);
      return
    }

    const newStepNumber = activeStep + 1
    const nextStep = steps[newStepNumber]
    nextStep?.href && navigate(`${nextStep?.href}`)
    const domElement = document.querySelector(`#${nextStep?.id}`)
    const newDomElement: any = domElement?.cloneNode(true)

    if (!domElement) {
      const tutorialBoxElement: any = tutorialBoxRef.current;
      onMobileShowWidget && onMobileShowWidget(true);
      tutorialBoxElement.style.cssText = "translate: -185px;";
      document.body.style.pointerEvents = "none";
      setTimeout(() => {
        onMobileShowWidget && onMobileShowWidget(false);
        tutorialBoxElement.removeAttribute("style");
        document.body.style.removeProperty("pointer-events");
      }, 4000);
    }

    if (newDomElement) {
      newDomElement?.setAttribute('id', `${nextStep.id}-clone`)
      const position = domElement?.getBoundingClientRect()

      newDomElement.style.cssText = `position: absolute; left: ${position?.x}px; top: ${position?.y}px; z-index: 1400; pointer-events: none; ${nextStep.id !== "side-menu" && 'width: 100%; animation: none'}`

      const ref = newDomElement.querySelector(`#${nextStep.elementRef}`)
      if (ref) {
        if (nextStep.elementRef) {
          if (nextStep.elementRef === "chatbot") {
            ref.style.cssText = "position: relative;"
            ref.classList.add('active-tutorial')

            const mark = document.createElement('div')
            mark.style.cssText = `position: absolute; left: 50%; top: 50%; translate: -52% -50%; width: 45px; height: 45px; border-radius: 100%; border: 1px solid ${theme.customColors.backgroundPrimaryCta}; box-shadow: 0px 0px 24px 0px ${theme.customColors.backgroundPrimaryCta}80; background: rgba(255,255,255,0.2)`
            ref.appendChild(mark)
          } else {
            ref.classList.add('active-tutorial')

            const mark = document.createElement('div')
            mark.style.cssText = `position: absolute; left: 50%; top: 50%; translate: -50% -50%; min-width: 120px; width: calc(100% + 20px); aspect-ratio: 1/1; border-radius: 100%; border: 1px solid ${theme.customColors.backgroundPrimaryCta}; box-shadow: 0px 0px 24px 0px ${theme.customColors.backgroundPrimaryCta}80; background: rgba(255,255,255,0.2)`
            ref.appendChild(mark)
          }
        }
      }

      // remove isActiveNavigationItem class (in tutorial viene usata active-tutorial per evidenziare l'elemento)
      const activeItem = newDomElement?.querySelector(".isActiveNavigationItem");
      if (activeItem) {
        activeItem.classList.remove("isActiveNavigationItem");
      }

      document.body.appendChild(newDomElement)
    }

    setActiveStep(newStepNumber)
  }

  const goNextStepMobile = () => {
    const elementToRemove = document.querySelector(`#${steps[activeStep].id}-clone`)
    elementToRemove?.remove()

    if (steps.length - 1 === activeStep) {
      setShowTutorial(false)
      if(origin) navigate(origin);
      return
    }

    const newStepNumber = activeStep + 1
    const nextStep = steps[newStepNumber]
    nextStep.href && navigate(`${nextStep.href}`)
    if (nextStep.id === "side-menu") {
      onMobileShowWidget && onMobileShowWidget(true)
      setShowTutorial(false)
      document.body.style.pointerEvents = "none"
      setTimeout(() => {
        document.body.style.removeProperty("pointer-events")
        setShowTutorial(true)
        onMobileShowWidget && onMobileShowWidget(false)
      }, 5000);
    }
    if (nextStep.id === "app-bar") {
      onMobileShowUserMenu && onMobileShowUserMenu(true)
      setShowTutorial(false)
      document.body.style.pointerEvents = "none"
      setTimeout(() => {
        document.body.style.removeProperty("pointer-events")
        setShowTutorial(true)
        onMobileShowUserMenu && onMobileShowUserMenu(false)
      }, 5000);
    }
    const domElement = document.querySelector(`#${nextStep.id}`)
    const newDomElement: any = domElement?.cloneNode(true)
    if (newDomElement) {
      newDomElement?.setAttribute('id', `${nextStep.id}-clone`)
      const position = domElement?.getBoundingClientRect()

      setShowTutorial(false)
      document.body.style.pointerEvents = "none"
      setTimeout(() => {
        document.body.style.removeProperty("pointer-events")
        setShowTutorial(true)
      }, 5000);

      newDomElement.style.cssText = `position: absolute; left: ${position?.x}px; top: ${position?.y}px; z-index: 1400; pointer-events: none; ${nextStep.id !== "side-menu" && 'width: 100%; animation: none'}`

      const ref = newDomElement.querySelector(`#${nextStep.elementRef}`)
      if (ref) {
        if (nextStep.elementRef) {
          ref.style.cssText = "position: relative; border: 0;"
          ref.classList.add('active-tutorial')

          const mark = document.createElement('div')
          mark.style.cssText = `position: absolute; left: 50%; top: 50%; translate: -50% -50%; width: 85px; aspect-ratio: 1/1; border-radius: 100%; border: 1px solid ${theme.customColors.backgroundPrimaryCta}; box-shadow: 0px 0px 24px 0px ${theme.customColors.backgroundPrimaryCta}80; background: rgba(255,255,255,0.2)`
          ref.appendChild(mark)
        }
      }

      document.body.appendChild(newDomElement)
    }

    setActiveStep(newStepNumber)
  }

  useEffect(() => {
    const clonedElements = document.querySelectorAll('[id$="-clone"]');

    clonedElements.forEach(el => {
      el.remove();
    });
  }, [])

  useEffect(() => {
    const step: any = steps[activeStep];
    const card: any = tutorialBoxRef.current;
    
    if (!showTutorial || isMobile || !step?.id) {
      if (card) card.style.cssText = "";
      return;
    }

    let rafId = 0;
    const place = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const el = document.querySelector(`#${step.id}`);
        if (!el || !card) return;
        const elRect = el.getBoundingClientRect();

        
        const clone: any = document.querySelector(`#${step.id}-clone`);
        if (clone) {
          clone.style.left = `${elRect.x}px`;
          clone.style.top = `${elRect.y}px`;
        }

        
        card.style.cssText = "";
        
        
        
      });
    };

    place();
    window.addEventListener("resize", place);
    const vv = window.visualViewport;
    vv?.addEventListener("resize", place);
    vv?.addEventListener("scroll", place);
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("resize", place);
      vv?.removeEventListener("resize", place);
      vv?.removeEventListener("scroll", place);
      if (card) card.style.cssText = "";
    };
  }, [activeStep, showTutorial, isMobile, steps])

  return (
    <Dialog open={showTutorial} sx={{
      [theme.breakpoints.up("md")]: {
        marginTop: "2rem"
      },
      ".MuiDialog-paper": {
        overflowY: "unset",
        background: "transparent",
        boxShadow: "none"
      }
    }}>
      <BoxCmt id="test" ref={tutorialBoxRef}>
        <Box sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "14px",
          marginBottom: isMobile ? "1.5rem" : "2rem"
        }}>
          <Typography
            fontWeight={700}
            fontSize={isMobile ? "1rem" : "1.25rem"}
            color={theme.customColors.backgroundPrimaryCta}
          >
            {t("tutorial-label")}
          </Typography>
          <Box
            id={"close"}
            role="button"
            tabIndex={0}
            aria-label={t("close")}
            onClick={() => closeTutorial()}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                closeTutorial();
              }
            }}
            sx={{
              display: "flex",
              cursor: "pointer",
              color: theme.customColors.textPrimary,
              "&:focus-visible": {
                outline: `2px solid ${theme.customColors.backgroundPrimaryCta}`,
                outlineOffset: "2px",
                borderRadius: "4px"
              }
            }}
          >
            <X size="1.25rem" />
          </Box>
        </Box>
        <Typography fontWeight={700} fontSize={isMobile ? "1.25rem" : "2rem"} lineHeight={1.1} marginBottom={2.5}>{steps[activeStep].title}</Typography>
        <Typography fontSize={isMobile ? "1rem" : "1.25rem"} lineHeight={1.3} marginBottom={1.5} color={alpha(theme.customColors.textPrimary, 0.7)}>
          {steps[activeStep].firstText}
        </Typography>
        <Typography fontSize={isMobile ? "1rem" : "1.25rem"} lineHeight={1.3} color={alpha(theme.customColors.textPrimary, 0.7)}>
          {steps[activeStep].secondText}
        </Typography>
        <Box sx={{
          marginTop: "2.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem"
        }}>
          <Box
            role="progressbar"
            aria-valuenow={activeStep + 1}
            aria-valuemin={1}
            aria-valuemax={steps.length}
            aria-label={`${activeStep + 1}/${steps.length}`}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem"
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  height: "0.375rem",
                  borderRadius: "1rem",
                  transition: "all 0.2s ease",
                  width: index === activeStep ? "1.5rem" : "0.375rem",
                  background: index === activeStep
                    ? theme.customColors.backgroundPrimaryCta
                    : alpha(theme.customColors.textPrimary, 0.3)
                }}
              />
            ))}
          </Box>
          <ButtonDigited
            id={"continue"}
            typology={"primary"}
            onClick={() => {
              if (steps.length - 1 === activeStep) {
                // localStorage.setItem("tutorial-completed", "true");
                closeTutorial()
              }
              if (isMobile) {
                goNextStepMobile()
              } else {
                goToNextStep()
              }
            }}
            sx={{
              [theme.breakpoints.down("sm")]: {
                minWidth: "151px",
                zIndex: theme.zIndex.appBar
              }
            }}
          >
            <>
              {steps.length - 1 === activeStep ? t("begin") : t("continue")}
              <ChevronRight size="1.25rem" />
            </>
          </ButtonDigited>
        </Box>
      </BoxCmt>
    </Dialog>
  );
}

export default TutorialBox;
